import React, {FC} from 'react';

export const TopBar: FC = () => {
  // TODO: Put something more fun here within the bar
  return <div className='top-bar'/>;
};